import { DropdownOption } from '@hawkins/components';
import { CameraSensorMode } from 'src/domains/api/cameras/types';
import { CalculatorBagItem } from 'src/domains/calculators/utilities/types';
import { KEY } from './constants';
import { FormikProps } from 'formik';
import { CalculatorOutputProps } from './components/CalculatorOutput/types';

export type CalculatorKey = typeof KEY;
export interface FormState {
  alignment: DropdownOption<string>;
  outputAspectRatio: DropdownOption<number>;
  lensSqueezeFactor: DropdownOption<number>;
  // nulls options are needed so the query params can parse
  // types that don't have default values
  sensorMode: DropdownOption<CameraSensorMode> | undefined | null;
  safetyCrop: number;
  customCameraAspectRatio: number | undefined | null;
  effectiveCanvasWidth: number | undefined | null;
  effectiveCanvasHeight: number | undefined | null;
  customFramingDecisionWidth: number | undefined | null;
  customFramingDecisionHeight: number | undefined | null;
  squeezedMode: SqueezedMode;
  framingIntentLabel: string;
  showTitle: string;
  directorOfPhotography: string;
  lockAspectRatio: boolean;
}

export interface CalculatorProps {
  key: CalculatorKey;
  initialValues?: FormState;
  onReset: (key: CalculatorKey) => void;
  onChange: (
    key: CalculatorKey,
    input: FormState,
    output: CalculatorOutputProps
  ) => void;
}

export interface CalculatorInputProps {
  form: FormikProps<FormState>;
  calculatedInputValues: {
    aspectRatio: number | null;
    protection: number | null;
  } | null;
  defaultFormValues: FormState;
  setFramingIntentLabelError: (error: boolean) => void;
}

export type CalculatorBag = CalculatorBagItem<
  CalculatorKey,
  CalculatorProps,
  CalculatorOutputProps,
  never
>;

export enum SqueezedMode {
  Squeezed = 0,
  Desqueezed = 1,
}
